import _ from 'lodash'
import viewName from '../constant.js'
import searchInput from './components/searchInput'
import {
    getCarBrand
} from '@/models/carBrandSelect'

export default {
    name: viewName.carBrandSelect,
    inject: ['showLoading', 'hideLoading'],
    components: {
        searchInput
    },
    data () {
        return {
            brandList: {},
            charList: [],
            searchBrandList: [],
            event: document.createEvent('HTMLEvents')
        }
    },
    directives: {
        scroll: {
            inserted: (el, binding) => {
                window.addEventListener('myscroll', (e) => {
                    if (binding.value === e.eventType) {
                        window.scrollTo(0, el.offsetTop)
                    }
                }, false)
            }
        }
    },
    async created () {
        this.$emit('setHeader', {
            title: '选择车品牌',
            showHeader: true,
            showLeft: true
        })
        this.event.initEvent('myscroll', true, true)
        this.getCarBrandList()
    },
    methods: {
        scrollToChar (char) {
            this.event.eventType = char
            document.dispatchEvent(this.event)
        },
        getCarBrandList (value = '', isSearch = false) {
            this.showLoading()
            getCarBrand({brand_name: value}).then((res) => {
                this.hideLoading()
                if (isSearch) {
                    let result = []
                    for (let i in res) {
                        result = result.concat(res[i])
                    }
                    this.searchBrandList = result
                } else {
                    this.brandList = res
                    this.charList = Object.keys(res)
                }
            })
        },
        onSearch (value) {

        },
        onClear () {
            this.searchBrandList = []
        },
        onInput: _.debounce(function (value) {
            if (!value) {
                this.searchBrandList = []
            } else {
                this.getCarBrandList(value, true)
            }
        }, 200)
    }
}
